import { ROLES } from "../common/enums";
import HomePage from "../pages/HomePage";
import InvolvementPage from "../pages/InvolvementPage";
import ErrorsPage from "../pages/ErrorsPage";
import HealthCheckPage from "../pages/HealthCheckPage";
import DashboardPage from "../features/home/Home";
import News from "../features/news/News";
import NewsId from "../features/news/newsById/NewsById";
import Сontests from "../features/contests/СontestsPage";
import ContestsById from "../features/contests/components/contestsById/ContestsById";
import Artists from "../features/artists/Artists";
import Pages from "../features/pages/Pages";
import PlaylistById from "../features/playlist/Playlist";
import PagesById from "../features/pages/pagesById/PagesById";
import Podcasts from "../features/podcasts/Podcasts";
import Contacts from "../features/contacts/Contacts";
import Rizdvoniki from "../pages/RizdvonikiLendingPage";
import SitemapViewer from "../pages/SitemapViewerPage";
import GoogleVerificationPage from "../pages/GoogleVerificationPage";

export const mainRoutes = {
  home: {
    title: "Home page",
    path: "/",
    element: HomePage,
  },
  notFound: {
    title: "Not found",
    path: "/not-found",
    element: ErrorsPage,
  },
  health: {
    title: "Health",
    path: "/health",
    element: HealthCheckPage,
  },
  rizdvonikiLending: {
    title: "RizdvonikiLendingPage",
    path: "/schedryk",
    element: Rizdvoniki,
  },
  sitemap: {
    title: "sitemap",
    path: "/sitemap.xml",
    element: SitemapViewer,
  },
  googleVerification: {
    title: "Google Verification",
    path: "/google4d4bf5e7f22bdd3e.html",
    element: GoogleVerificationPage,
  },
};

export const dashBoardRoutes = {
  dashboard: {
    title: "Dashboard",
    path: "/",
    element: DashboardPage,
    permissions: [ROLES.ADMIN],
  },
  podcasts: {
    title: "Podcasts",
    path: "/podcasts",
    element: Podcasts,
    permissions: [ROLES.ADMIN],
  },
  news: {
    title: "News",
    path: "/news",
    element: News,
    permissions: [ROLES.ADMIN],
  },
  newsId: {
    title: "NewsId",
    path: "/news/:id",
    element: NewsId,
    permissions: [ROLES.ADMIN],
  },
  pages: {
    title: "Pages",
    path: "/pages",
    element: Pages,
    permissions: [ROLES.ADMIN],
  },
  pagesId: {
    title: "PagesId",
    path: "/pages/:id",
    element: PagesById,
    permissions: [ROLES.ADMIN],
  },
  contests: {
    title: "Contests",
    path: "/contests",
    element: Сontests,
    permissions: [ROLES.ADMIN],
  },
  artistId: {
    title: "ArtistId",
    path: "artists/:publicUrl",
    element: Artists,
    permissions: [ROLES.ADMIN],
  },
  playlistByUrl: {
    title: "PlaylistByUrl",
    path: "playlists/:publicUrl",
    element: PlaylistById,
    permissions: [ROLES.ADMIN],
  },
  currentContestsById: {
    title: "CurrentContestsById",
    path: "contests/:publicUrl",
    element: ContestsById,
    permissions: [ROLES.ADMIN],
  },
  involvement: {
    title: "Involvement",
    path: "/application/:publicUrl",
    element: InvolvementPage,
    permissions: [ROLES.ADMIN],
  },
  contacts: {
    title: "Contacts",
    path: "/contacts",
    element: Contacts,
    permissions: [ROLES.ADMIN],
  },
};
